import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import HttpClient from '../../utils/HttpClient';

//Fetch All
export const fetchAllNotifications = createAsyncThunk('Data/AllNotification', async () => {
    const response = await HttpClient.requestData("all-notification", "GET", {});

    return response.data;
});

//  Delete
export const deleteNotification = createAsyncThunk('Data/DeleteNotification', async (id) => {
    const response = await HttpClient.requestData(`notification-delete/${id}`, "DELETE");
    return response.data;
});

//Read All
export const readAllNotifications = createAsyncThunk('Data/ReadAllNotification', async () => {
    const response = await HttpClient.requestData("read-notification", "POST", {});
    return response.data;
});

export const fetchPendingInvitations = createAsyncThunk('Data/FetchPendingInvitations', async () => {
    const response = await HttpClient.requestData("pending-directory", "GET", {});
    return response.data;
});

// Create the Data slice
const notificationSlice = createSlice({
    name: 'Data',
    initialState: {
        AllNotifications: [],
        UnreadNotificationsCount: 0,
        status: '',
        error: null,
        pendingInvitations: [],
        pendingInvitationsCount: 0,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetching Notification Data
            .addCase(fetchAllNotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAllNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.AllNotifications = action?.payload?.filter(item => item?.userId !== item?.visitedBy)?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
                state.UnreadNotificationsCount = action?.payload?.filter(item => item.readStatus !== "read").length;
            })
            .addCase(fetchAllNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action?.error.message;
            })
            // Deleting Notification Data
            .addCase(deleteNotification.pending, (state) => {
                state.status = 'deleting';
            })
            .addCase(deleteNotification.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // state.AllNotifications = action?.payload?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
            })
            .addCase(deleteNotification.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action?.error.message;
            })
            // Read Notification Data
            .addCase(readAllNotifications.pending, (state) => {
                state.status = 'reading';
            })
            .addCase(readAllNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.UnreadNotificationsCount = 0
            })
            .addCase(readAllNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action?.error.message;
            })
            //Read invitation Data
            .addCase(fetchPendingInvitations.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPendingInvitations.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.pendingInvitations = action?.payload || [];
                state.pendingInvitationsCount = action?.payload?.length || 0;
            })
            .addCase(fetchPendingInvitations.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action?.error.message;
            })
    },
});

export const { } = notificationSlice.actions
export default notificationSlice.reducer

// Export the asynchronous thunks for use in components or other parts of your application